import { createContext, useReducer, useState } from "react";
import { Cliente } from "../Model/Clientes";

const clien:Cliente=
    {
        nombre:"",
        apellidoPaterno:"",
        apellidoMaterno:"",
        rut:0,
        digitoVerificadorRut:"",
        fechaNacimiento:"",
        email:"",
        sexo:0,
        lDirecciones:[],
        contrasena:"",
        lCasilla:[{
            ecode:"",
            Contenido:{
                CasillaMiami:false,
                CasillaEspana:false,
                id:0,
                puntosRewards:[],
              }
        }],
        Eleccion:0
    }
export const Contexto=createContext<any>(clien);

const reducer=(state:any,action:any):Cliente=>
{
    switch(action.type){
        case "Cliente":return action.input.cliente;

        case "Eleccion":return {...state,Eleccion:action.input.eleccion}

        case "Espana":return {...state,CasillaEspana:"true"}

        case "Sexo":return {...state,sexo:action.input.eleccion}

        case "Reinicio": return clien;
    }
    
    return state
}

export const Datos=({children}:any)=>
{
    const [Cli,dispatch]=useReducer(reducer,clien);

    const ActualizarCli=(clie:Cliente)=>
    {
        dispatch({type:"Cliente",input:{cliente:clie}})
    }

    const ActualizarCasilla=(number:number)=>
    {
        dispatch({type:"Eleccion",input:{eleccion:number}})
    }

    const ActualizarEspana=()=>
    {
        dispatch({type:"Espana"})
    }

    const ActualizarSexo=(sexo:number)=>
    {
        dispatch({type:"Sexo",input:{eleccion:sexo}})
    }

    const cierreSession=()=>
    {
        dispatch({type:"Reinicio"})
    }

    return (
        <Contexto.Provider value={{Cli,ActualizarCli,ActualizarCasilla,ActualizarEspana,ActualizarSexo,cierreSession}}>
            {children}
        </Contexto.Provider>
    )
}
  
